import React, { useEffect, useState } from "react";
import useHandlePlayerArrays from "../../hooks/useHandlePlayerArrays";
import useSearchLocally from "../../hooks/useSearchLocally";
import ObjectListHolder from "./ObjectListHolder";
import SmallItemHolder from "./SmallItemHolder";

const ObjectIdHolder = ({ objectId, type, onClick }) => {
  const [objects, setObjects] = useState(null);
  const { findObjectById } = useHandlePlayerArrays();

  useEffect(() => {
    const check = typeof objectId === "object";

    findObjectById(check ? objectId.id : objectId, type, (objects) => {
      setObjects(objects);
    });
  }, [objectId]);

  return (
    <div className="divRow" style={{ width: "100%" }}>
      {objects && (
        <SmallItemHolder
          item={objects.general}
          onClicked={onClick}
          width={"100%"}
        />
      )}
    </div>
  );
};

export default ObjectIdHolder;
